import { render, staticRenderFns } from "./DialogGroupConsentDetail.vue?vue&type=template&id=547f34c8&"
import script from "./DialogGroupConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogGroupConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports